import "./types.mjs";
import { a as e, i as t, n, r, t as i } from "./client-C353vByp.js";
import { a, c as o, i as s, n as c, o as l, r as u, s as d, t as f } from "./store-CfeUiT2k.js";
import { n as p, t as m } from "./organization-CsI1biu8.js";
import { AuthLoading as h, Authenticated as g, Unauthenticated as _ } from "./components.mjs";
import { canChangeUserRole as v, canDeleteOrganization as y, canDeleteUser as b, hasGovernancePermission as x, hasOrganizationPermission as S, isGuestRole as C, isReadOnlyRole as w, isViewingOwnProfile as T } from "./rbac.mjs";
//#region src/platform-admin.ts
function E(e) {
	return e?.platformAdmin === !0 && (e.role === "owner" || e.role === "admin");
}
//#endregion
//#region src/home.ts
function D(e, t = window.location.origin) {
	if (e?.homeApp !== "chat" || !e.homeUrl) return null;
	let n;
	try {
		n = new URL(e.homeUrl);
	} catch {
		return null;
	}
	return n.protocol !== "https:" && n.protocol !== "http:" || n.origin === t ? null : n.toString();
}
//#endregion
export { i as AUTH_CALLBACK_PATH, n as AuthCallbackError, r as AuthClient, h as AuthLoading, f as AuthProvider, g as Authenticated, l as DEFAULT_KEEPALIVE_INTERVAL_MS, d as KEEPALIVE_LOCK_NAME, _ as Unauthenticated, v as canChangeUserRole, y as canDeleteOrganization, b as canDeleteUser, D as chatHomeForward, a as handleUnauthorized, x as hasGovernancePermission, S as hasOrganizationPermission, t as isAuthCallbackPath, C as isGuestRole, E as isPlatformAdmin, w as isReadOnlyRole, T as isViewingOwnProfile, e as safeReturnPath, o as startKeepalive, c as useAuth, p as useAuthCallback, u as useAuthConfig, s as useAuthStore, m as useOrganization };

//# sourceMappingURL=index.mjs.map